/* QueryStatusComponent.js */

"use strict";

const EventEmitter = require("events");
const _ = require("lodash");
const Renderer = require("./QueryStatusRenderer");
const { QUERY_STATUSES } = require("./QueryStatusConstant");

class QueryStatusComponent extends EventEmitter {
    constructor(value, context) {
        super();
        this._value = value;
        this._adhocDetails = context.adhocDetails;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._adhocDetails = undefined;
        return prom;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    setValue() {
        this.emit("Update");
    }

    getColumnData() {
        if (_.get(this._adhocDetails, "_adHocRun", false) || _.get(this._adhocDetails, "_lastRunSelected", false)) {
            return QUERY_STATUSES[this._value.getStatus()];
        }
        return QUERY_STATUSES.UNKNOWN;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = QueryStatusComponent;
